import { useMemo } from "react";

import jsonParse from "web/utils/data/parser/string/jsonParse";
import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { Optional } from "web/types/Utils";

interface IPathsData {
  ids: number[];
  tree: string[];
}
const useTreeAndIds = ({
  paths,
  rootCategoryId,
}: {
  paths: string;
  rootCategoryId: number;
}) =>
  useMemo(() => {
    const pathsParsed = jsonParse<string[]>(paths);
    const pathsData = isArrayHasItems(pathsParsed)
      ? pathsParsed.reduce<IPathsData>(
          (result, path) => {
            if (typeof path === "string") {
              const rootCategoryIdString = `/${rootCategoryId}/`;
              const rootCategoryIdIndex = path.indexOf(rootCategoryIdString);
              if (rootCategoryIdIndex !== -1) {
                const pathProcessed = path.slice(
                  rootCategoryIdIndex + rootCategoryIdString.length
                );
                const idsCurrent = pathProcessed?.split("/").map((el) => +el);

                return {
                  ids: Array.from(new Set([...result.ids, ...idsCurrent])),
                  tree: [...result.tree, pathProcessed],
                };
              }
            }
            return result;
          },
          { ids: [], tree: [] }
        )
      : [];

    return pathsData as Optional<IPathsData>;
  }, [paths]);

export default useTreeAndIds;
